import React from 'react'

const PartnersHome = () => {
  return (
    <div>Partners Home</div>
  )
}

export default PartnersHome